import algoliasearch from 'algoliasearch'

import type { SearchClient, AlgoliaSearchOptions } from 'algoliasearch'
import type { DeviceType } from '~/types/device-type'

import { COMMON_LOKALISE_PROJECT_ID } from '~/const/lokalise'

export const getSearchClient = (options?: AlgoliaSearchOptions): SearchClient =>
  algoliasearch(process.env.ALGOLIA_API_ID || '', process.env.ALGOLIA_API_KEY || '', options)

export const getTranslationFilters = ({
  deviceType,
  locale = 'en',
  lokaliseId,
}: {
  deviceType: DeviceType
  locale?: 'en'
  lokaliseId?: string
}): string => {
  if (!lokaliseId) {
    return `locale:${locale} AND device_type:${deviceType} AND lokalise_project_id:${COMMON_LOKALISE_PROJECT_ID}`
  }
  return `locale:${locale} AND device_type:${deviceType} AND (lokalise_project_id:${lokaliseId} OR lokalise_project_id:${COMMON_LOKALISE_PROJECT_ID})`
}

export const getIapFilters = ({ appKey, deviceType }: { appKey: string; deviceType: DeviceType }): string =>
  `device_type:${deviceType} AND app_key:${appKey}`
